export default [
  {
    text: 'Country',
    value: 'country.name',
    apiSort: 'country',
  },
  {
    text: 'Name',
    value: 'name',
  },
  {
    text: 'Type',
    value: 'type',
    apiSort: 'is_system_label',
    width: '23%',
  },
  {
    text: 'Color',
    value: 'color',
  },
  {
    text: ' ',
    value: 'actions',
    action: 'delete',
    icon: 'delete',
    width: '160px',
    sortable: false,
  },
];
